import { random } from "lodash";
import {API} from "../../backend"
// API is basically path

// Backend for Signup
export const signup = admin => {
    return fetch(`${API}/adminsignup`, {
        method: "POST",
        headers: {
            "Accept" : "application/json",
            "Content-Type" : "application/json"
        },
        body: JSON.stringify(admin)
    })
    
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
};


// Backend for Signin
export const signin = admin => {
    return fetch(`${API}/adminsignin`, {
        method: "POST",
        headers: {
            "Accept" : "application/json",
            "Content-Type" : "application/json"
        },
        body: JSON.stringify(admin)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
};

export const changePassword = (adminPassword, adminId, token) => {
    return fetch(`${API}/admin/password/change/${adminId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(adminPassword)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
};


export const authenticate = (data, next) => {
    if(typeof window !== "undefined") {
        localStorage.setItem("eSession", JSON.stringify(data))
        next();
    }
}

// Backend for Signout
export const signout = next => {
    if(typeof window !== "undefined") {
        localStorage.removeItem("eSession")
        next();

        return fetch(`${API}/adminsignout`, {
          method: "GET"  
        })
        .catch(err => console.log(err))
    }
};

export const isAuthenticated = () => {
    if(typeof window == "undefined") {
        return false
    }
    if(localStorage.getItem("eSession")) {
        return JSON.parse(localStorage.getItem("eSession"));
    } else {
        return false;
    }
};

export const updateAdminPrivileges = (newIsSuperAdmin, newPrivileges) => {
  if (typeof window !== "undefined") {
    const session = localStorage.getItem("eSession");
    if (session) {
      try {
        const parsedSession = JSON.parse(session);

        // Update only what’s needed
        if (parsedSession.admin) {
          parsedSession.admin.isSuperAdmin = newIsSuperAdmin;
          parsedSession.admin.privileges = newPrivileges;

          localStorage.setItem("eSession", JSON.stringify(parsedSession));
        }
      } catch (err) {
        console.error("Failed to update admin privileges in localStorage:", err);
      }
    }
  }
};